/* eslint-disable @typescript-eslint/no-explicit-any */
import { Children, type ReactNode } from 'react'

function isIterable<T extends {}>(obj: T): obj is Extract<T, Iterable<any>> {
  if (!(Symbol.iterator in obj)) {
    return false
  }
  return typeof obj[Symbol.iterator] === 'function'
}

function isPromiseLike<T extends {}>(obj: T): obj is Extract<T, Promise<any>> {
  return 'then' in obj && typeof obj.then === 'function'
}

function isElementWithChildren(obj: unknown): obj is { children: ReactNode } {
  return (
    !!obj &&
    typeof obj === 'object' &&
    'children' in obj &&
    !!obj.children &&
    typeof (obj as unknown as { children: ReactNode }).children !== 'function'
  )
}

function reactNodeToString(node: ReactNode): string {
  switch (typeof node) {
    case 'string':
      return node
    case 'number':
    case 'bigint':
    case 'boolean':
    case 'symbol':
      return node.toString()
    case 'undefined':
      return ''
    case 'object': {
      if (!node) return ''
      if (isPromiseLike(node)) return '[Promise]'
      if (isIterable(node)) return Array.from(node).map(reactNodeToString).join('')
      if (isElementWithChildren(node.props))
        return Children.toArray(node.props.children).map(reactNodeToString).join('')
      return ''
    }
    default:
      return ''
  }
}

export function toId(node: ReactNode): string {
  return reactNodeToString(node)
    .toLowerCase()
    .replaceAll(/[^a-z0-9-_]/g, '-')
}

export default reactNodeToString
